export async function usePageQuery(total, perPage, queryKey = "page") {
  const route = useRoute();
  const requested = Number(route.query[queryKey]);
  const rawPage = computed(() => Number(route.query[queryKey]) || 1);
  const totalPages = Math.max(1, Math.ceil((total || 0) / perPage));

  if (requested === 1) {
    const { [queryKey]: _, ...rest } = route.query;
    await navigateTo({ path: route.path, query: rest }, { redirectCode: 301, replace: true });
  }

  if (requested > totalPages) {
    await navigateTo(
      { path: route.path, query: { ...route.query, [queryKey]: totalPages } },
      { redirectCode: 301, replace: true }
    );
  }

  return {
    currentPage: computed(() => Math.min(Math.max(1, rawPage.value), totalPages)),
    totalPages,
  };
}